import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { SEO } from '../../utils/seo';

export default function ApprochePage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://mykinesiologue.ma';

  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "@id": `${siteUrl}/approche#webpage`,
    "url": `${siteUrl}/approche`,
    "name": "Approche - MyKinesiologue Marrakech",
    "description": "La kinésiologie combine une lecture fine du corps et un ensemble de techniques structurées. Le travail s'adapte à chaque personne, sans protocole figé, en respectant le rythme propre à chacun.",
    "isPartOf": {
      "@type": "WebSite",
      "@id": `${siteUrl}/#website`
    },
    "about": {
      "@type": "Service",
      "name": "Kinésiologie",
      "description": "Approche précise et respectueuse utilisant le test musculaire et des techniques variées pour accompagner le stress et les tensions.",
      "provider": {
        "@type": "LocalBusiness",
        "@id": `${siteUrl}/#organization`
      }
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-[#F7F3EE]">
      <SEO
        title="Approche - Kinésiologie Marrakech | MyKinesiologue"
        description="La kinésiologie combine une lecture fine du corps et un ensemble de techniques structurées. Le travail s'adapte à chaque personne, sans protocole figé, en respectant le rythme propre à chacun."
        keywords="approche kinésiologie, test musculaire, techniques kinésiologie, méthode kinésiologie Marrakech"
        canonical={`${siteUrl}/approche`}
        schema={schema}
      />

      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-400 ${isScrolled ? 'bg-white shadow-sm' : 'bg-transparent'}`}>
        <div className="max-w-[1120px] mx-auto px-4 md:px-8 py-4 md:py-6 flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img src="https://static.readdy.ai/image/48f019ad192905b3f4ede24b194a300b/9e4b5e4e7afefada3563c5975e98200f.png" alt="MyKinesiologue" className="h-8 md:h-12" />
          </Link>
          
          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-[#1F1F1F] cursor-pointer"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`} style={{ fontSize: '24px' }}></i>
          </button>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-6">
            <Link to="/" className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-300" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px' }}>Accueil</Link>
            <Link to="/approche" className="text-[#1F4D45] font-semibold transition-colors duration-300" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px' }}>Approche</Link>
            <Link to="/a-qui-sadresse" className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-300" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px' }}>À qui s'adresse</Link>
            <Link to="/presence" className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-300" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px' }}>Présence</Link>
            <Link to="/contenus-multimedia" className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-300" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px' }}>Contenus multimédia</Link>
            <Link to="/prendre-rendez-vous" className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-300" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px' }}>Prendre rendez-vous</Link>
            <Link to="/faq" className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-300" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px' }}>FAQ</Link>
            <Link to="/prendre-rendez-vous#contact" className="bg-[#1F4D45] text-[#F7F3EE] px-6 h-11 rounded-2xl flex items-center justify-center whitespace-nowrap hover:bg-[#1F4D45]/90 hover:translate-y-[-1px] transition-all duration-300 cursor-pointer ml-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px', fontWeight: '500' }}>Me contacter</Link>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-[#C9C1B8]">
            <div className="px-4 py-6 flex flex-col gap-4">
              <Link to="/" onClick={() => setIsMobileMenuOpen(false)} className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-400 py-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>Accueil</Link>
              <Link to="/approche" onClick={() => setIsMobileMenuOpen(false)} className="text-[#1F4D45] font-medium transition-colors duration-400 py-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>Approche</Link>
              <Link to="/a-qui-sadresse" onClick={() => setIsMobileMenuOpen(false)} className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-400 py-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>À qui s'adresse</Link>
              <Link to="/presence" onClick={() => setIsMobileMenuOpen(false)} className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-400 py-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>Présence</Link>
              <Link to="/contenus-multimedia" onClick={() => setIsMobileMenuOpen(false)} className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-400 py-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>Contenus multimédia</Link>
              <Link to="/prendre-rendez-vous" onClick={() => setIsMobileMenuOpen(false)} className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-400 py-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>Prendre rendez-vous</Link>
              <Link to="/faq" onClick={() => setIsMobileMenuOpen(false)} className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-400 py-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>FAQ</Link>
              <Link to="/prendre-rendez-vous#contact" onClick={() => setIsMobileMenuOpen(false)} className="bg-[#1F4D45] text-[#F7F3EE] px-6 h-12 rounded-2xl flex items-center justify-center whitespace-nowrap cursor-pointer mt-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>Me contacter</Link>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section className="pt-24 md:pt-32 pb-16 md:pb-24 bg-[#F7F3EE]">
        <div className="max-w-[1120px] mx-auto px-4 md:px-8">
          <div className="max-w-[900px] mx-auto text-center">
            <h1 className="text-[#1F1F1F] mb-6 md:mb-8" style={{ fontFamily: 'Fraunces, serif', fontSize: '50px', lineHeight: '1.1', fontWeight: '600' }}>
              Une approche précise, respectueuse et personnalisée
            </h1>
            <p className="text-[#5E5A55] text-lg leading-relaxed max-w-[800px] mx-auto" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
              La kinésiologie combine une lecture fine du corps et un ensemble de techniques structurées. Le travail s'adapte à chaque personne, sans protocole figé, en respectant le rythme propre à chacun.
            </p>
          </div>
        </div>
      </section>

      {/* Test Musculaire Section */}
      <section className="py-16 md:py-24 bg-[#F7F3EE]">
        <div className="max-w-[1120px] mx-auto px-4 md:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
            <div>
              <img 
                src="https://public.readdy.ai/ai/img_res/8a611abfdcd8c6ad92023fe3c34d63b6.jpg" 
                alt="Test musculaire" 
                className="w-full h-[450px] md:h-[650px] object-cover object-top rounded-[24px]"
              />
            </div>
            <div>
              <h2 className="text-[#1F1F1F] mb-6 md:mb-8" style={{ fontFamily: 'Fraunces, serif', fontSize: '35px', lineHeight: '1.2', fontWeight: '600' }}>
                Le test musculaire
              </h2>
              <p className="text-[#5E5A55] mb-4" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
                Le test musculaire est l'outil central de la kinésiologie.
              </p>
              <p className="text-[#5E5A55] mb-4" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
                Il permet d'observer comment le corps réagit à différents stimuli et d'identifier des zones de surcharge ou de stress encore actifs.
              </p>
              <p className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
                <strong>C'est le corps qui guide la séance, pas une interprétation extérieure.</strong>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Techniques Section */}
      <section className="py-16 md:py-24 bg-[#F7F3EE]">
        <div className="max-w-[1120px] mx-auto px-4 md:px-8">
          <div className="max-w-[900px] mx-auto">
            <h2 className="text-[#1F1F1F] mb-8 md:mb-12 text-center" style={{ fontFamily: 'Fraunces, serif', fontSize: '35px', lineHeight: '1.2', fontWeight: '600' }}>
              Les techniques utilisées
            </h2>
            <p className="text-[#5E5A55] mb-8 md:mb-12 text-center" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
              Selon les indications du corps, différentes techniques peuvent être mobilisées, notamment :
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="bg-white/60 backdrop-blur-sm p-6 rounded-[20px] border border-[#C9C1B8]/30">
                <div className="w-12 h-12 flex items-center justify-center mb-4">
                  <i className="ri-flow-chart text-[#1F4D45]" style={{ fontSize: '32px' }}></i>
                </div>
                <h3 className="text-[#1F1F1F] mb-3" style={{ fontFamily: 'Fraunces, serif', fontSize: '24px', lineHeight: '1.3', fontWeight: '600' }}>
                  Méridiens et chiropractie
                </h3>
                <p className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px', lineHeight: '1.6' }}>
                  Le travail sur les méridiens et les apports des chiropracteurs
                </p>
              </div>

              <div className="bg-white/60 backdrop-blur-sm p-6 rounded-[20px] border border-[#C9C1B8]/30">
                <div className="w-12 h-12 flex items-center justify-center mb-4">
                  <i className="ri-heart-pulse-line text-[#1F4D45]" style={{ fontSize: '32px' }}></i>
                </div>
                <h3 className="text-[#1F1F1F] mb-3" style={{ fontFamily: 'Fraunces, serif', fontSize: '24px', lineHeight: '1.3', fontWeight: '600' }}>
                  Libération du stress
                </h3>
                <p className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px', lineHeight: '1.6' }}>
                  Des techniques de libération du stress
                </p>
              </div>

              <div className="bg-white/60 backdrop-blur-sm p-6 rounded-[20px] border border-[#C9C1B8]/30">
                <div className="w-12 h-12 flex items-center justify-center mb-4">
                  <i className="ri-parent-line text-[#1F4D45]" style={{ fontSize: '32px' }}></i>
                </div>
                <h3 className="text-[#1F1F1F] mb-3" style={{ fontFamily: 'Fraunces, serif', fontSize: '24px', lineHeight: '1.3', fontWeight: '600' }}>
                  Kinésiologie périnatale
                </h3>
                <p className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px', lineHeight: '1.6' }}>
                  La kinésiologie périnatale
                </p>
              </div>

              <div className="bg-white/60 backdrop-blur-sm p-6 rounded-[20px] border border-[#C9C1B8]/30">
                <div className="w-12 h-12 flex items-center justify-center mb-4">
                  <i className="ri-brain-line text-[#1F4D45]" style={{ fontSize: '32px' }}></i>
                </div>
                <h3 className="text-[#1F1F1F] mb-3" style={{ fontFamily: 'Fraunces, serif', fontSize: '24px', lineHeight: '1.3', fontWeight: '600' }}>
                  Psychologie clinique
                </h3>
                <p className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px', lineHeight: '1.6' }}>
                  Des apports issus de la psychologie clinique
                </p>
              </div>

              <div className="bg-white/60 backdrop-blur-sm p-6 rounded-[20px] border border-[#C9C1B8]/30">
                <div className="w-12 h-12 flex items-center justify-center mb-4">
                  <i className="ri-hand-heart-line text-[#1F4D45]" style={{ fontSize: '32px' }}></i>
                </div>
                <h3 className="text-[#1F1F1F] mb-3" style={{ fontFamily: 'Fraunces, serif', fontSize: '24px', lineHeight: '1.3', fontWeight: '600' }}>
                  Acupression
                </h3>
                <p className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px', lineHeight: '1.6' }}>
                  L'acupression
                </p>
              </div>

              <div className="bg-white/60 backdrop-blur-sm p-6 rounded-[20px] border border-[#C9C1B8]/30">
                <div className="w-12 h-12 flex items-center justify-center mb-4">
                  <i className="ri-clockwise-line text-[#1F4D45]" style={{ fontSize: '32px' }}></i>
                </div>
                <h3 className="text-[#1F1F1F] mb-3" style={{ fontFamily: 'Fraunces, serif', fontSize: '24px', lineHeight: '1.3', fontWeight: '600' }}>
                  Hypnose
                </h3>
                <p className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px', lineHeight: '1.6' }}>
                  Des techniques inspirées de l'hypnose
                </p>
              </div>
            </div>

            <p className="text-[#5E5A55] mt-8 md:mt-12 text-center italic" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
              Chaque séance est construite à partir de ce qui est pertinent à l'instant présent.
            </p>
          </div>
        </div>
      </section>

      {/* Cadre Éthique Section */}
      <section className="py-16 md:py-24 bg-[#F7F3EE]">
        <div className="max-w-[1120px] mx-auto px-4 md:px-8">
          <div className="max-w-[800px] mx-auto bg-white/60 backdrop-blur-sm p-8 md:p-12 rounded-[28px] border-2 border-[#1F4D45]/20">
            <div className="flex items-start gap-4 md:gap-6 mb-6">
              <div className="w-12 h-12 flex items-center justify-center flex-shrink-0">
                <i className="ri-shield-check-line text-[#1F4D45]" style={{ fontSize: '36px' }}></i>
              </div>
              <h2 className="text-[#1F1F1F]" style={{ fontFamily: 'Fraunces, serif', fontSize: '35px', lineHeight: '1.2', fontWeight: '600' }}>
                Cadre éthique
              </h2>
            </div>
            <p className="text-[#5E5A55] mb-4" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
              La kinésiologie n'est pas une pratique médicale et ne se substitue ni à un diagnostic ni à un traitement.
            </p>
            <p className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
              Elle repose sur une obligation de moyens, et non de résultats.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section id="contact" className="py-16 md:py-32 bg-[#F7F3EE]">
        <div className="max-w-[1120px] mx-auto px-4 md:px-8 text-center">
          <h2 className="text-[#1F1F1F] mb-4 md:mb-6" style={{ fontFamily: 'Fraunces, serif', fontSize: '35px', lineHeight: '1.2', fontWeight: '600' }}>
            Prêt à commencer ?
          </h2>
          <p className="text-[#5E5A55] mb-8 md:mb-12 max-w-2xl mx-auto" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
            Prenez rendez-vous pour découvrir comment la kinésiologie peut vous accompagner
          </p>
          <a href="mailto:contact@mykinesiologue.ma" className="inline-flex items-center gap-3 bg-[#1F4D45] text-[#F7F3EE] px-6 md:px-8 h-12 rounded-2xl whitespace-nowrap hover:translate-y-[-2px] transition-all duration-400 cursor-pointer" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>
            <i className="ri-calendar-line"></i>
            Prendre rendez-vous
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#1F4D45] py-12 md:py-16">
        <div className="max-w-[1120px] mx-auto px-4 md:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mb-8 md:mb-12">
            <div>
              <Link to="/" className="inline-block mb-4">
                <img src="https://static.readdy.ai/image/48f019ad192905b3f4ede24b194a300b/9e4b5e4e7afefada3563c5975e98200f.png" alt="MyKinesiologue" className="h-10" />
              </Link>
              <p className="text-[#E9E0D4]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>
                Kinésiologie à Marrakech
              </p>
            </div>
            <div>
              <h3 className="text-[#E9E0D4] uppercase tracking-wider mb-4" style={{ fontFamily: 'Inter, sans-serif', fontSize: '12px', letterSpacing: '1.5px' }}>
                Navigation
              </h3>
              <div className="grid grid-cols-2 gap-x-6 gap-y-2">
                <Link to="/" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>Accueil</Link>
                <Link to="/contenus-multimedia" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>Contenus multimédia</Link>
                <Link to="/approche" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>Approche</Link>
                <Link to="/prendre-rendez-vous" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>Prendre rendez-vous</Link>
                <Link to="/a-qui-sadresse" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>À qui s'adresse</Link>
                <Link to="/faq" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>FAQ</Link>
                <Link to="/presence" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>Présence</Link>
              </div>
            </div>
            <div>
              <h3 className="text-[#E9E0D4] uppercase tracking-wider mb-4" style={{ fontFamily: 'Inter, sans-serif', fontSize: '12px', letterSpacing: '1.5px' }}>
                Contact
              </h3>
              <div className="flex flex-col gap-2">
                <a href="mailto:contact@mykinesiologue.ma" className="text-[#F7F3EE] hover:underline break-all" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>contact@mykinesiologue.ma</a>
                <a href="tel:+212600000000" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>+212 6 00 00 00 00</a>
                <p className="text-[#E9E0D4] mt-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>
                  Marrakech, Maroc
                </p>
              </div>
            </div>
          </div>
          <div className="border-t border-[#F7F3EE]/20 pt-6 text-center">
            <p className="text-[#E9E0D4]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '12px' }}>
              © 2025 MyKinesiologue. Tous droits réservés.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
